import { render, staticRenderFns } from "./deviceStatusPage.vue?vue&type=template&id=4b64c0b5&scoped=true"
import script from "./deviceStatusPage.vue?vue&type=script&lang=js"
export * from "./deviceStatusPage.vue?vue&type=script&lang=js"
import style0 from "./deviceStatusPage.vue?vue&type=style&index=0&id=4b64c0b5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b64c0b5",
  null
  
)

export default component.exports